import getUrlDict from './getUrlDict'
import { TEST_MODE, localStorageGet } from './utils'
import { env } from './env'

export function log(
  string1?: string,
  string2?: string | boolean | object | number,
  string3?: string | boolean | object | number,
  inputsChanged?: {}
) {
  if (getUrlDict().savvy_debug || localStorageGet('savvy_debug')) {
    console.log(...arguments)
  }
}
export function time() {
  if (getUrlDict().savvy_debug || localStorageGet('savvy_debug')) {
    console.time(...arguments)
  }
}
export function timeEnd() {
  if (getUrlDict().savvy_debug || localStorageGet('savvy_debug')) {
    console.timeEnd(...arguments)
  }
}
export function logGroupCollapsed(name: String) {
  if (getUrlDict().savvy_debug || localStorageGet('savvy_debug')) {
    console.groupCollapsed(name)
  }
}
export function logGroupEnd() {
  if (getUrlDict().savvy_debug || localStorageGet('savvy_debug')) {
    console.groupEnd()
  }
}

// ;(TEST_MODE ? console.log : log)('TEST_MODE:', TEST_MODE)
// ;(TEST_MODE ? console.log : log)('ENV:', env())
